import axios from "axios";

import {appUrls} from "helpers/Urls";
import axiosInstance from "utils/axiosInstance";

export const ListLogBookApi = async (pageParam, patientId) => {
    let LogData = await axiosInstance.get(appUrls.Logs(patientId, pageParam, 20));
    return LogData.data;
};
export const GridLogBookApi = () => {
    const fetchData = async (patientId, page) => {
        let LogData = await axiosInstance.get(appUrls.GridGlucoseChart(page, page, patientId));
        console.log(page, patientId)
        return LogData.data;
    };
    return fetchData;
}



